import {agendaDirectory} from "./access/patientDirectory";
import { useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import EvolutionCard from "./EvolutionCard";
import { db, auth } from "./firebase";
import {
    registerPayment
} from "./services/registerPayment";

import {
    collection,
    addDoc,
    doc,
    updateDoc,
    serverTimestamp
} from "./access/firestore";
import { createAppointment } from "./services/createAppointment";

export default function EvolutionPanel({

    paciente,

    clinicId,

    clinicData,

    citas,

    pagos

}) {

    const [
        evolucionPanel,
        setEvolucionPanel
    ] = useState("consultas");

    const [
        consultaFechaDesde,
        setConsultaFechaDesde
    ] = useState("");

    const [
        consultaFechaHasta,
        setConsultaFechaHasta
    ] = useState("");

    const [
        tratamientoFiltro,
        setTratamientoFiltro
    ] = useState("Todos");

    const [
        pagoFechaDesde,
        setPagoFechaDesde
    ] = useState("");

    const [
        pagoFechaHasta,
        setPagoFechaHasta
    ] = useState("");

    const [
        conceptoFiltro,
        setConceptoFiltro
    ] = useState("Todos");

    const [
        searchPago,
        setSearchPago
    ] = useState("");

    const [
        mostrarNuevaNota,
        setMostrarNuevaNota
    ] = useState(false);

    const ahora = () => {

    const fecha = new Date();

        return fecha.toLocaleTimeString(

            "es-MX",

            {

                hour: "2-digit",

                minute: "2-digit",

                hour12: false

            }

        );

    };

    const hoy = () => {

        const fecha = new Date();

        fecha.setMinutes(

            fecha.getMinutes()

            - fecha.getTimezoneOffset()

        );

        return fecha
            .toISOString()
            .split("T")[0];

    };

    const [
        nuevaNota,
        setNuevaNota
    ] = useState({

        fecha: hoy(),

        hora: ahora(),

        motivo: "",

        tratamiento: "",

        notas: "",

        presupuesto: "",

        pagado: "",

        proximo: "",

        doctorId: "",

        doctorNombre: "",

        estado: "pendiente",

        agendarCita: false,

        proximaFecha: "",

        proximaHora: "",

        proximaDuracion: "30",

        proximoMotivo: "",

        proximoPresupuesto: "",

        metodoPago: "efectivo",

        enviarReciboWhatsApp: true

    });

    const [
        guardando,
        setGuardando
    ] = useState(false);

    const saldoPendiente =

        Math.max(

            0,

            Number(nuevaNota.presupuesto || 0)

            -

            Number(nuevaNota.pagado || 0)

        );

    const guardarNuevaNota = async () => {

        try {

            setGuardando(true);

            const presupuesto =
                Number(nuevaNota.presupuesto || 0);

            const pagado =
                Number(nuevaNota.pagado || 0);

            const saldo =
                Math.max(
                    0,
                    presupuesto - pagado
                );

            // =========================
            // CREAR REGISTRO DE EVOLUCIÓN
            // =========================

            const citasRef = agendaDirectory(db,clinicId);

            const nuevaCita = {

                pacienteId:
                    paciente.id,

                pacienteNombre:
                    `${paciente.nombre} ${paciente.apellidos || ""}`.trim(),

                fecha:
                    nuevaNota.fecha,

                hora:
                    nuevaNota.hora,

                motivo:
                    nuevaNota.motivo,

                tratamiento:
                    nuevaNota.tratamiento,

                presupuesto,

                pagado: 0,

                saldo:
                    presupuesto,

                duracion:
                    "30",

                notas:
                    nuevaNota.notas,

                proximo:
                    nuevaNota.proximo,

                estado:
                    saldo === 0
                        ? "pagada"
                        : "activa",

                doctorId:
                    auth.currentUser?.uid || "",

                doctorNombre:
                    nuevaNota.doctorNombre || "",

                doctorColor:
                    "#3b82f6",

                // IMPORTANTE:
                // esto identifica que NO es una cita
                origen:
                    "manual",

                tipoRegistro:
                    "evolucion",

                createdAt:
                    serverTimestamp()

            };

            const citaDoc =
                await addDoc(
                    citasRef,
                    nuevaCita
                );

            const cita = {

                id:
                    citaDoc.id,

                ...nuevaCita,

                cuentaPorCobrarId:
                    null

            };

            // =========================
            // CUENTA POR COBRAR
            // =========================

            if (presupuesto > 0) {

                const cuentaRef =
                    await addDoc(

                        collection(
                            db,
                            "clinics",
                            clinicId,
                            "pacientes",
                            paciente.id,
                            "cuentasPorCobrar"
                        ),

                        {

                            clinicId,

                            tipo:
                                "evolucion",

                            citaId:
                                citaDoc.id,

                            descripcion:
                                nuevaNota.motivo?.trim()
                                ||
                                "Consulta dental",

                            total:
                                presupuesto,

                            pagado:
                                0,

                            saldo:
                                presupuesto,

                            estado:
                                "Pendiente",

                            createdAt:
                                serverTimestamp()

                        }

                    );

                cita.cuentaPorCobrarId =
                    cuentaRef.id;

                await updateDoc(

                    doc(
                        db,
                        "clinics",
                        clinicId,
                        "citas",
                        citaDoc.id
                    ),

                    {

                        cuentaPorCobrarId:
                            cuentaRef.id

                    }

                );

            }

            // =========================
            // REGISTRAR PAGO
            // =========================

            if (pagado > 0) {

                await registerPayment({

                    clinicId,

                    clinicData,

                    paciente,

                    cita,

                    monto:
                        pagado,

                    metodoPago:
                        nuevaNota.metodoPago,

                    enviarReciboWhatsApp:
                        nuevaNota.enviarReciboWhatsApp

                });

            }

            // =========================
            // CREAR SIGUIENTE CITA
            // SOLO SI SE SOLICITÓ
            // =========================

            if (nuevaNota.agendarCita) {

                await createAppointment({

                    clinicId,

                    clinicData,

                    paciente,

                    form: {

                        fecha:
                            nuevaNota.proximaFecha,

                        hora:
                            nuevaNota.proximaHora,

                        motivo:
                            nuevaNota.proximoMotivo,

                        tratamiento:
                            "",

                        presupuesto:
                            nuevaNota.proximoPresupuesto,

                        duracion:
                            nuevaNota.proximaDuracion,

                        notas:
                            "",

                        proximo:
                            "",

                        estado:
                            "activa",

                        doctorId:
                            auth.currentUser?.uid || "",

                        doctorNombre:
                            nuevaNota.doctorNombre || "",

                        doctorColor:
                            "#3b82f6"

                    }

                });

            }

            // =========================
            // CERRAR
            // =========================

            setMostrarNuevaNota(false);

            setNuevaNota({

                fecha:
                    hoy(),

                hora:
                    ahora(),

                motivo:
                    "",

                tratamiento:
                    "",

                notas:
                    "",

                presupuesto:
                    "",

                pagado:
                    "",

                proximo:
                    "",

                doctorId:
                    "",

                doctorNombre:
                    "",

                estado:
                    "pendiente",

                agendarCita:
                    false,

                proximaFecha:
                    "",

                proximaHora:
                    "",

                proximaDuracion:
                    "30",

                proximoMotivo:
                    "",

                proximoPresupuesto:
                    "",

                metodoPago:
                    "efectivo",

                enviarReciboWhatsApp:
                    true

            });

        }

        catch (error) {

            console.error(
                "ERROR GUARDANDO NOTA DE EVOLUCIÓN:",
                error
            );

            alert(
                error.message
            );

        }

        finally {

            setGuardando(false);

        }

    };

    const card = {
        background:"#fff",
        padding:18,
        borderRadius:16,
        boxShadow:"0 6px 20px rgba(0,0,0,.06)",
        display:"flex",
        flexDirection:"column",
        gap:10
    };

    const buttonSecondary = {
        padding:"8px 12px",
        borderRadius:8,
        border:"none",
        background:"#e5e7eb",
        cursor:"pointer"
    };

    const subTabStyle = (active)=>({

        padding:"10px 18px",

        border:"none",

        borderBottom:

            active

                ? "3px solid #2563eb"

                : "3px solid transparent",

        background:"transparent",

        color:

            active

                ? "#2563eb"

                : "#6b7280",

        fontWeight:700,

        cursor:"pointer"

    });

    const consultasFiltradas =

        evolucionPanel === "consultas"

            ? (citas || [])

                .filter(cita => {

                    if (
                        consultaFechaDesde &&
                        cita.fecha < consultaFechaDesde
                    ) {
                        return false;
                    }

                    if (
                        consultaFechaHasta &&
                        cita.fecha > consultaFechaHasta
                    ) {
                        return false;
                    }

                    if (
                        tratamientoFiltro !== "Todos" &&
                        cita.tratamiento !== tratamientoFiltro
                    ) {
                        return false;
                    }

                    return true;

                })

                .sort((a, b) =>

                    new Date(`${b.fecha} ${b.hora || "00:00"}`)

                    -

                    new Date(`${a.fecha} ${a.hora || "00:00"}`)

                )

                .map(cita => ({
                    tipo: "consulta",
                    data: cita
                }))

            : (pagos || []).map(pago => ({
                tipo: "pago",
                data: pago
            }));

    const pagosFiltrados =

        (pagos || [])

            .filter(pago => {

                const fechaPago = pago.fecha?.seconds

                    ? new Date(pago.fecha.seconds * 1000)

                    : null;

                if (

                    pagoFechaDesde &&

                    fechaPago &&

                    fechaPago < new Date(pagoFechaDesde)

                ) {

                    return false;

                }

                if (

                    pagoFechaHasta &&

                    fechaPago &&

                    fechaPago > new Date(`${pagoFechaHasta}T23:59:59`)

                ) {

                    return false;

                }

                if (

                    conceptoFiltro !== "Todos" &&

                    pago.concepto !== conceptoFiltro

                ) {

                    return false;

                }

                const texto =

                    `${pago.folio || ""} ${pago.concepto || ""}`

                        .toLowerCase();

                if (

                    !texto.includes(

                        searchPago.toLowerCase()

                    )

                ) {

                    return false;

                }

                return true;

            })

            .sort((a, b) =>

                (b.fecha?.seconds || 0)

                -

                (a.fecha?.seconds || 0)

            )

            .map(pago => ({

                tipo: "pago",

                data: pago

            }));

    const tratamientosPaciente = [

        "Todos",

        ...Array.from(

            new Set(

                consultasFiltradas

                    .map(evento => evento.data?.tratamiento)

                    .filter(Boolean)

            )

        ).sort()

    ];

    const conceptosPago = [

        "Todos",

        ...Array.from(

            new Set(

                (pagos || [])

                    .map(p => p.concepto)

                    .filter(Boolean)

            )

        ).sort()

    ];

    const formatearFecha = (fecha) => {

        if (!fecha) return "—";

        const [anio, mes, dia] = fecha.split("-");

        const meses = [
            "enero",
            "febrero",
            "marzo",
            "abril",
            "mayo",
            "junio",
            "julio",
            "agosto",
            "septiembre",
            "octubre",
            "noviembre",
            "diciembre"
        ];

        return `${parseInt(dia)} de ${meses[parseInt(mes)-1]} de ${anio}`;

    };

    return (

        <>

        {/* NOTAS DE EVOLUCIÓN */}

                <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 20
                }}
                >

                <div style={card}>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: 20
                        }}
                    >

                        <h2
                            style={{
                                margin: 0
                            }}
                        >
                            Evolución
                        </h2>

                        <button

                            onClick={() =>
                                setMostrarNuevaNota(true)
                            }

                            style={{

                                background:"#2563eb",

                                color:"#fff",

                                border:"none",

                                borderRadius:10,

                                padding:"10px 18px",

                                fontWeight:600,

                                cursor:"pointer"

                            }}

                        >

                            + Nueva nota

                        </button>

                    </div>

                    <div
                    style={{

                        display:"flex",

                        borderBottom:"1px solid #e5e7eb",

                        marginBottom:24

                    }}
                    >

                    <button

                        style={subTabStyle(
                        evolucionPanel === "consultas"
                        )}

                        onClick={() =>
                        setEvolucionPanel(
                            "consultas"
                        )
                        }

                    >

                        Consultas

                    </button>

                    <button

                        style={subTabStyle(
                        evolucionPanel === "pagos"
                        )}

                        onClick={() =>
                        setEvolucionPanel(
                            "pagos"
                        )
                        }

                    >

                        Pagos

                    </button>

                    </div>

                    <div
                    style={{

                        display: "flex",

                        flexWrap: "wrap",

                        gap: 16,

                        alignItems: "flex-end",

                        marginBottom: 24,

                        padding: 16,

                        background: "#f8fafc",

                        border: "1px solid #e5e7eb",

                        borderRadius: 12

                    }}
                    >

                    {evolucionPanel === "consultas" && (
                        <>

                    <div>

                        <label
                        style={{
                            display: "block",
                            marginBottom: 6,
                            fontWeight: 600
                        }}
                        >
                        Desde
                        </label>

                        <input
                            type="date"
                            value={consultaFechaDesde}
                            onChange={e=>setConsultaFechaDesde(e.target.value)}
                        />

                    </div>

                    <div>

                        <label
                        style={{
                            display: "block",
                            marginBottom: 6,
                            fontWeight: 600
                        }}
                        >
                        Hasta
                        </label>

                        <input
                        type="date"
                        value={consultaFechaHasta}
                        onChange={e=>setConsultaFechaHasta(e.target.value)}
                        />

                    </div>

                    <div>

                        <label
                        style={{
                            display: "block",
                            marginBottom: 6,
                            fontWeight: 600
                        }}
                        >
                        Tratamiento realizado
                        </label>

                        <select

                        value={tratamientoFiltro}

                        onChange={e =>
                            setTratamientoFiltro(
                            e.target.value
                            )
                        }

                        >

                        {

                            tratamientosPaciente.map(

                            tratamiento => (

                                <option
                                key={tratamiento}
                                value={tratamiento}
                                >

                                {tratamiento}

                                </option>

                            )

                            )

                        }

                        </select>

                    </div>

                    <button

                        style={buttonSecondary}

                        onClick={() => {

                        setConsultaFechaDesde("");

                        setConsultaFechaHasta("");

                        setTratamientoFiltro(
                            "Todos"
                        );

                        }}

                    >

                        Limpiar filtros

                    </button>

                        </>
                    )}

                    {evolucionPanel === "pagos" && (
                        <>

                            <div>

                                <label
                                    style={{
                                        display: "block",
                                        marginBottom: 6,
                                        fontWeight: 600
                                    }}
                                >
                                    Desde
                                </label>

                                <input
                                    type="date"
                                    value={pagoFechaDesde}
                                    onChange={e =>
                                        setPagoFechaDesde(e.target.value)
                                    }
                                />

                            </div>

                            <div>

                                <label
                                    style={{
                                        display: "block",
                                        marginBottom: 6,
                                        fontWeight: 600
                                    }}
                                >
                                    Hasta
                                </label>

                                <input
                                    type="date"
                                    value={pagoFechaHasta}
                                    onChange={e =>
                                        setPagoFechaHasta(e.target.value)
                                    }
                                />

                            </div>

                            <div>

                                <label
                                    style={{
                                        display: "block",
                                        marginBottom: 6,
                                        fontWeight: 600
                                    }}
                                >
                                    Concepto
                                </label>

                                <select
                                    value={conceptoFiltro}
                                    onChange={e =>
                                        setConceptoFiltro(e.target.value)
                                    }
                                >

                                    {conceptosPago.map(concepto => (

                                        <option
                                            key={concepto}
                                            value={concepto}
                                        >
                                            {concepto}
                                        </option>

                                    ))}

                                </select>

                            </div>

                            <div>

                                <label
                                    style={{
                                        display: "block",
                                        marginBottom: 6,
                                        fontWeight: 600
                                    }}
                                >
                                    Buscar
                                </label>

                                <input

                                    type="text"

                                    placeholder="Folio o concepto..."

                                    value={searchPago}

                                    onChange={e =>
                                        setSearchPago(
                                            e.target.value
                                        )
                                    }

                                />

                            </div>

                            <button

                                style={buttonSecondary}

                                onClick={() => {

                                    setPagoFechaDesde("");

                                    setPagoFechaHasta("");

                                    setConceptoFiltro("Todos");

                                    setSearchPago("");

                                }}

                            >

                                Limpiar filtros

                            </button>

                        </>
                    )}

                    </div>

                    {

                    (
                        evolucionPanel === "consultas"

                            ? consultasFiltradas

                            : pagosFiltrados

                    ).map(evento => {

                        // ==========================
                        // CONSULTAS
                        // ==========================

                        if (evento.tipo === "consulta") {

                            const cita = evento.data;

                            return (

                                <EvolutionCard

                                    cita={cita}

                                    clinicId={clinicId}

                                    formatearFecha={formatearFecha}

                                />

                            );

                        }

                        // ==========================
                        // PAGOS
                        // ==========================

                        if (evento.tipo === "pago") {

                        const pago = evento.data;

                        return (

                            <div

                            key={pago.id}

                            style={{

                                background:"#f0fdf4",

                                border:"1px solid #bbf7d0",

                                borderLeft:"6px solid #22c55e",

                                borderRadius:14,

                                padding:20,

                                marginBottom:24,

                                boxShadow:"0 4px 12px rgba(0,0,0,.05)"

                            }}

                            >

                            <div
                                style={{
                                fontSize:12,
                                color:"#15803d",
                                fontWeight:700,
                                letterSpacing:1,
                                marginBottom:8
                                }}
                            >
                                PAGO
                            </div>

                            <div
                                style={{
                                fontSize:18,
                                fontWeight:700,
                                marginBottom:18
                                }}
                            >
                                {

                                pago.fecha?.seconds

                                    ? new Date(
                                        pago.fecha.seconds * 1000
                                    ).toLocaleDateString(
                                        "es-MX"
                                    )

                                    : "—"

                                }
                            </div>

                            <div
                                style={{
                                display:"grid",
                                gridTemplateColumns:"180px 1fr",
                                rowGap:12
                                }}
                            >

                                <strong>
                                Concepto
                                </strong>

                                <div>
                                {pago.concepto || "—"}
                                </div>

                                <strong>
                                Monto
                                </strong>

                                <div>
                                $
                                {Number(
                                    pago.monto || 0
                                ).toLocaleString("es-MX")}
                                </div>

                                <strong>
                                Método
                                </strong>

                                <div>
                                {pago.metodoPago || "—"}
                                </div>

                                <strong>
                                Folio
                                </strong>

                                <div>
                                {pago.folio || "—"}
                                </div>

                            </div>

                            </div>

                        );

                        }

                        return null;

                    })

                    }

                    {

                        (

                            evolucionPanel === "consultas"

                                ? consultasFiltradas.length

                                : pagosFiltrados.length

                        ) === 0 && (

                            <div
                                style={{
                                    color:"#6b7280",
                                    textAlign:"center",
                                    padding:30
                                }}
                            >

                                No se encontraron registros con los filtros seleccionados.

                            </div>

                        )

                    }

                </div>

                </div>

            {

                mostrarNuevaNota && (

                    <>

                        <div

                            onClick={() =>
                                setMostrarNuevaNota(false)
                            }

                            style={{

                                position:"fixed",

                                inset:0,

                                background:"rgba(0,0,0,.35)",

                                zIndex:999

                            }}

                        />

                        <div

                            style={{
                                position:"fixed",

                                top:0,

                                right:0,

                                bottom:0,

                                width:500,

                                maxWidth:"100%",

                                height:"100dvh",

                                background:"#fff",

                                zIndex:2000,

                                boxShadow:"-8px 0 24px rgba(0,0,0,.15)",

                                display:"flex",

                                flexDirection:"column"
                            }}

                        >

                            <div

                                style={{

                                    padding:"calc(16px + env(safe-area-inset-top)) 20px 16px",
                                    borderBottom:"1px solid #e5e7eb",
                                    display:"flex",
                                    justifyContent:"space-between",
                                    alignItems:"center",
                                    flexShrink:0

                                }}

                            >

                                <h2
                                    style={{
                                        margin:0
                                    }}
                                >

                                    Nueva nota de evolución

                                </h2>

                                <button

                                    onClick={() =>
                                        setMostrarNuevaNota(false)
                                    }

                                    style={{

                                        background:"transparent",

                                        border:"none",

                                        fontSize:26,

                                        cursor:"pointer"

                                    }}

                                >

                                    ×

                                </button>

                            </div>

                            <div

                                style={{

                                    flex:1,
                                    padding:"24px 20px",
                                    paddingBottom:"120px",
                                    overflowY:"auto",
                                    WebkitOverflowScrolling:"touch"

                                }}

                            >

                                <div
                                    style={{
                                        display:"flex",
                                        flexDirection:"column",
                                        gap:18
                                    }}
                                >

                                    <div>

                                        <label style={{fontWeight:600}}>
                                            Fecha
                                        </label>

                                        <input

                                            type="date"

                                            value={nuevaNota.fecha}

                                            onChange={e=>

                                                setNuevaNota({

                                                    ...nuevaNota,

                                                    fecha:e.target.value

                                                })

                                            }

                                            style={{
                                                width:"100%"
                                            }}

                                        />

                                    </div>

                                    <div>

                                        <label style={{fontWeight:600}}>
                                            Hora
                                        </label>

                                        <input

                                            type="time"

                                            value={nuevaNota.hora}

                                            onChange={e =>

                                                setNuevaNota({

                                                    ...nuevaNota,

                                                    hora: e.target.value

                                                })

                                            }

                                            style={{
                                                width:"100%"
                                            }}

                                        />

                                    </div>

                                    <div>

                                        <label style={{fontWeight:600}}>
                                            Motivo de consulta
                                        </label>

                                        <input

                                            type="text"

                                            value={nuevaNota.motivo}

                                            onChange={e=>

                                                setNuevaNota({

                                                    ...nuevaNota,

                                                    motivo:e.target.value

                                                })

                                            }

                                            style={{
                                                width:"100%"
                                            }}

                                        />

                                    </div>

                                    <div>

                                        <label style={{fontWeight:600}}>
                                            Tratamiento realizado
                                        </label>

                                        <input

                                            type="text"

                                            value={nuevaNota.tratamiento}

                                            onChange={e=>

                                                setNuevaNota({

                                                    ...nuevaNota,

                                                    tratamiento:e.target.value

                                                })

                                            }

                                            style={{
                                                width:"100%"
                                            }}

                                        />

                                    </div>

                                    <div>

                                        <label style={{fontWeight:600}}>
                                            Nota de evolución
                                        </label>

                                        <textarea

                                            rows={6}

                                            value={nuevaNota.notas}

                                            onChange={e=>

                                                setNuevaNota({

                                                    ...nuevaNota,

                                                    notas:e.target.value

                                                })

                                            }

                                            style={{
                                                width:"100%",
                                                resize:"vertical"
                                            }}

                                        />

                                    </div>

                                    <hr
                                        style={{
                                            border: "none",
                                            borderTop: "1px solid #e5e7eb"
                                        }}
                                    />

                                    <h3
                                        style={{
                                            margin: 0,
                                            color: "#374151"
                                        }}
                                    >
                                        Información financiera
                                    </h3>

                                    <div>

                                        <label style={{ fontWeight: 600 }}>
                                            Presupuesto
                                        </label>

                                        <input

                                            type="number"

                                            min="0"

                                            step="0.01"

                                            value={nuevaNota.presupuesto}

                                            onChange={e =>

                                                setNuevaNota({

                                                    ...nuevaNota,

                                                    presupuesto: e.target.value

                                                })

                                            }

                                            style={{
                                                width: "100%"
                                            }}

                                        />

                                    </div>

                                    <div>

                                        <label style={{ fontWeight: 600 }}>
                                            Pago recibido
                                        </label>

                                        <input

                                            type="number"

                                            min="0"

                                            step="0.01"

                                            value={nuevaNota.pagado}

                                            onChange={e =>

                                                setNuevaNota({

                                                    ...nuevaNota,

                                                    pagado: e.target.value

                                                })

                                            }

                                            style={{
                                                width: "100%"
                                            }}

                                        />

                                    </div>

                                    <div>

                                        <label style={{ fontWeight: 600 }}>
                                            Método de pago
                                        </label>

                                        <select

                                            value={nuevaNota.metodoPago}

                                            onChange={e =>

                                                setNuevaNota({

                                                    ...nuevaNota,

                                                    metodoPago: e.target.value

                                                })

                                            }

                                            style={{
                                                width: "100%"
                                            }}

                                        >

                                            <option value="efectivo">
                                                Efectivo
                                            </option>

                                            <option value="tarjeta">
                                                Tarjeta
                                            </option>

                                            <option value="transferencia">
                                                Transferencia
                                            </option>

                                        </select>

                                    </div>

                                    <label
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 8
                                        }}
                                    >

                                        <input

                                            type="checkbox"

                                            checked={nuevaNota.enviarReciboWhatsApp}

                                            onChange={e =>

                                                setNuevaNota({

                                                    ...nuevaNota,

                                                    enviarReciboWhatsApp: e.target.checked

                                                })

                                            }

                                        />

                                        Enviar recibo por WhatsApp

                                    </label>

                                    <div
                                        style={{

                                            background:"#f8fafc",

                                            border:"1px solid #dbeafe",

                                            borderRadius:10,

                                            padding:16

                                        }}
                                    >

                                        <strong>

                                            Saldo pendiente

                                        </strong>

                                        <div
                                            style={{
                                                marginTop:8,
                                                fontSize:22,
                                                fontWeight:700,
                                                color:"#dc2626"
                                            }}
                                        >

                                            $

                                            {saldoPendiente.toLocaleString("es-MX", {

                                                minimumFractionDigits:2,

                                                maximumFractionDigits:2

                                            })}

                                        </div>

                                    </div>

                                    <hr
                                        style={{
                                            border: "none",
                                            borderTop: "1px solid #e5e7eb"
                                        }}
                                    />

                                    <div>

                                        <label style={{ fontWeight:600 }}>
                                            Próximo tratamiento
                                        </label>

                                        <input

                                            type="text"

                                            value={nuevaNota.proximo}

                                            onChange={e =>

                                                setNuevaNota({

                                                    ...nuevaNota,

                                                    proximo: e.target.value

                                                })

                                            }

                                            style={{
                                                width:"100%"
                                            }}

                                        />

                                    </div>

                                    <hr
                                        style={{
                                            border: "none",
                                            borderTop: "1px solid #e5e7eb"
                                        }}
                                    />

                                    <div
                                        style={{

                                            display:"flex",

                                            justifyContent:"space-between",

                                            alignItems:"center"

                                        }}
                                    >

                                        <div>

                                            <div
                                                style={{
                                                    fontWeight:600
                                                }}
                                            >

                                                Agendar siguiente cita

                                            </div>

                                            <div
                                                style={{
                                                    fontSize:13,
                                                    color:"#6b7280"
                                                }}
                                            >

                                                Crear automáticamente una nueva cita al guardar.

                                            </div>

                                        </div>

                                        <input

                                            type="checkbox"

                                            checked={nuevaNota.agendarCita}

                                            onChange={e=>

                                                setNuevaNota({

                                                    ...nuevaNota,

                                                    agendarCita:e.target.checked

                                                })

                                            }

                                        />

                                    </div>

                                    {

                                        nuevaNota.agendarCita && (

                                            <div
                                                style={{

                                                    display:"flex",

                                                    flexDirection:"column",

                                                    gap:16,

                                                    marginTop:10,

                                                    padding:20,

                                                    background:"#f8fafc",

                                                    border:"1px solid #dbeafe",

                                                    borderRadius:12

                                                }}
                                            >

                                                <div>

                                                    <label style={{fontWeight:600}}>
                                                        Fecha
                                                    </label>

                                                    <input

                                                        type="date"

                                                        value={nuevaNota.proximaFecha}

                                                        onChange={e=>

                                                            setNuevaNota({

                                                                ...nuevaNota,

                                                                proximaFecha:e.target.value

                                                            })

                                                        }

                                                        style={{
                                                            width:"100%"
                                                        }}

                                                    />

                                                </div>

                                                <div>

                                                    <label style={{fontWeight:600}}>
                                                        Hora
                                                    </label>

                                                    <input

                                                        type="time"

                                                        value={nuevaNota.proximaHora}

                                                        onChange={e=>

                                                            setNuevaNota({

                                                                ...nuevaNota,

                                                                proximaHora:e.target.value

                                                            })

                                                        }

                                                        style={{
                                                            width:"100%"
                                                        }}

                                                    />

                                                </div>

                                                <div>

                                                    <label style={{fontWeight:600}}>
                                                        Duración (minutos)
                                                    </label>

                                                    <input

                                                        type="number"

                                                        min="5"

                                                        step="5"

                                                        value={nuevaNota.proximaDuracion}

                                                        onChange={e=>

                                                            setNuevaNota({

                                                                ...nuevaNota,

                                                                proximaDuracion:e.target.value

                                                            })

                                                        }

                                                        style={{
                                                            width:"100%"
                                                        }}

                                                    />

                                                </div>

                                                <div>

                                                    <label style={{fontWeight:600}}>
                                                        Motivo de la cita
                                                    </label>

                                                    <input

                                                        type="text"

                                                        value={nuevaNota.proximoMotivo}

                                                        onChange={e=>

                                                            setNuevaNota({

                                                                ...nuevaNota,

                                                                proximoMotivo:e.target.value

                                                            })

                                                        }

                                                        style={{
                                                            width:"100%"
                                                        }}

                                                    />

                                                </div>

                                                <div>

                                                    <label style={{fontWeight:600}}>
                                                        Presupuesto
                                                    </label>

                                                    <input

                                                        type="number"

                                                        min="0"

                                                        step="0.01"

                                                        value={nuevaNota.proximoPresupuesto}

                                                        onChange={e =>

                                                            setNuevaNota({

                                                                ...nuevaNota,

                                                                proximoPresupuesto: e.target.value

                                                            })

                                                        }

                                                        style={{
                                                            width:"100%"
                                                        }}

                                                    />

                                                </div>

                                            </div>

                                        )

                                    }

                                    <div

                                        style={{

                                            display:"flex",

                                            justifyContent:"flex-end",

                                            gap:12,

                                            marginTop:30,

                                            paddingTop:20,

                                            borderTop:"1px solid #e5e7eb"

                                        }}

                                    >

                                        <button

                                            onClick={() =>

                                                setMostrarNuevaNota(false)

                                            }

                                            style={{

                                                padding:"10px 20px",

                                                border:"1px solid #d1d5db",

                                                borderRadius:10,

                                                background:"#fff",

                                                cursor:"pointer",

                                                fontWeight:600

                                            }}

                                        >

                                            Cancelar

                                        </button>

                                        <button

                                            onClick={guardarNuevaNota}

                                            disabled={guardando}

                                            style={{

                                                padding:"10px 20px",

                                                border:"none",

                                                borderRadius:10,

                                                background: guardando ? "#9ca3af" : "#2563eb",

                                                color:"#fff",

                                                cursor: guardando ? "not-allowed" : "pointer",

                                                fontWeight:600

                                            }}

                                        >

                                            {
                                                guardando
                                                    ? "Guardando..."
                                                    : "Guardar"
                                            }

                                        </button>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </>

                )

            }

        </>
    );

}

